import styled from "styled-components";
import { BoxShadow, BoxShadowHover } from "../../../../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../../styles/common/mixins/logical.styled.js";
export const SkeletonsContainer = styled.div.withConfig({
    displayName: "styled__SkeletonsContainer",
    componentId: "sc-dbcd949d-0"
})``;
export const SkeletonItem = styled.div.withConfig({
    displayName: "styled__SkeletonItem",
    componentId: "sc-dbcd949d-1"
})`
	${FlexMixin({
    direction: 'column'
})}
	${BorderRadius({
    all: '4px'
})}
	${BoxShadowHover}
	${BoxShadow}
	overflow: hidden;
`;
export const SkeletonBody = styled.div.withConfig({
    displayName: "styled__SkeletonBody",
    componentId: "sc-dbcd949d-2"
})`
	border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.lighter};
	padding: 24px 12px 16px 12px;

	& div {
		margin-bottom: 12px;
	}
`;
export const SkeletonFooter = styled.div.withConfig({
    displayName: "styled__SkeletonFooter",
    componentId: "sc-dbcd949d-3"
})`
	${FlexMixin({
    align: 'center',
    justify: 'end'
})}
	padding:12px;
`;

//# sourceMappingURL=styled.js.map